import { useState } from "react";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Logo from "../assets/images/CDC FINAL LOGO - 01.png";
import footerBg from "../assets/images/Footer-5.jpg"; 
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="text-black relative overflow-hidden bg-cover bg-no-repeat bg-center"
      style={{
        backgroundImage: `url(${footerBg})`,
        backgroundPosition: 'center',
        backgroundSize:'object-fit'
      }}
    >
      {/* Optional overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-20 z-0" />

      {/* Footer Content */}
      <div className="relative z-10 container mx-auto px-6 py-16 md:py-20 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-12">
        {/* Newsletter */}
        <div className="flex-1">
          <p className="uppercase text-sm tracking-wide mb-1 text-black opacity-70 font-Matter">
            Stay up to date
          </p>
          <h2 className="text-4xl md:text-6xl font-black text-black leading-tight font-Antique">
            get our <br /> newsletter
          </h2>
          <form className="mt-8 flex items-center relative border-b border-black w-full">
            <input
              type="email"
              required
              placeholder="Your Email"
              className="bg-transparent text-black placeholder-black focus:outline-none w-4/5 py-2 ps-2 pe-20 font-Matter"
            />
            <div className="absolute -top-10 right-2 text-white rounded-full flex pt-1 justify-center text-2xl">
              <button className="group relative inline-flex mt-3 w-14 h-14 items-center rounded-full font-semibold text-white bg-transparent overflow-hidden">
                <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>

                <span className="relative">
                  <span className="flex flex-row gap-2 justify-center ps-4 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <ArrowForwardIcon />
                  </span>
                  <span className="absolute flex flex-row gap-2 top-0 ps-4 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <ArrowForwardIcon />
                  </span>
                </span>
              </button>
            </div>
          </form>
        </div>

        {/* Center Logo */}
        <div className="hidden md:flex justify-center xl:ps-0 ps-16 items-center flex-1">
          <img src={Logo} alt="Logo" className="w-[200px] mx-auto" />
        </div>

        {/* Contact Info */}
        <div className="flex-1 text-left lg:text-right">
          <p className="uppercase text-sm tracking-wide mb-1 text-black opacity-70 font-Matter">
            Get in touch
          </p>
          <p className="text-2xl md:text-3xl font-bold text-black font-Antique">
            <a
              href="mailto:info@cdc.com"
              className="text-black hover:text-[#37081a] transition-colors duration-300 no-underline"
            >
              info@cdc.com
            </a>
          </p>
          <p className="text-2xl md:text-3xl font-bold text-black mb-2 font-Antique">
            <a
              href="tel:+3527959200"
              className="text-black hover:text-[#37081a] transition-colors duration-300 no-underline"
            >
              +352-795-9200
            </a>
          </p>
          <Link
            to="https://maps.app.goo.gl/MQ5H5FsCB4nBt8dy7"
            target="_blank"
            className="text-black font-Matter"
          >
            922 North Citrus Avenue <br />
            Crystal River, Florida 34428
          </Link>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="relative z-10  py-6 px-6 text-sm text-black flex flex-col md:flex-row justify-center md:justify-between items-center gap-4">
        <div className="flex justify-center flex-wrap xl:gap-4 gap-2 opacity-70 font-Antique">
          <a href="/">Privacy Policy</a>
          <a href="/">Disclaimer</a>
          <a href="/">Terms and Conditions</a>
          <span className="flex gap-1 items-center">
            copy Rights <div className="text-[30px] font-semibold">©</div> 2025
          </span>
        </div>

        <div className="flex lg:flex-row flex-col justify-center items-center gap-4 font-Antique">
          <span className="text-center">See what we're up to</span>
          <span className="flex justify-between gap-2">
            <Link to="https://www.facebook.com/pages/Citrus-Diagnostic-Center/125806944133191">
              <FaFacebookF className="text-[20px]" />
            </Link>
            <FaLinkedinIn className="text-[25px]" />
            <FaInstagram className="text-[25px]" />
            <FaYoutube className="text-[25px]" />
          </span>
        </div>

        <div className="flex justify-center items-center">
          <Link
            to="https://www.novatales.com/"
            target="_blank"
            className="opacity-70 font-Antique text-center"
          >
            Powered by Novatales
          </Link>
        </div>
      </div>
    </footer>
  );
}
